module.exports = __webpack_public_path__ + "static/media/pic4.b5347aaf.jpg";